import React, { createContext, useContext, useState } from "react";

const translations = {
  de: {
    brand: "Fleet Area",
    subtitle: "Geräteflotten-Überwachung",
    login_title: "Anmeldung",
    login_desc: "Melde dich an, um die Geräteflotte zu verwalten.",
    email: "E-Mail",
    password: "Passwort",
    sign_in: "Anmelden",
    signing_in: "Anmeldung läuft…",
    logout: "Abmelden",
    dashboard: "Übersicht",
    installer: "Agent installieren",
    search_placeholder: "Suche: Hostname, Code, Seriennr., UUID, TeamViewer…",
    total: "Geräte gesamt",
    online: "Online",
    offline: "Offline",
    unassigned: "Code offen",
    all: "Alle",
    device_code: "Geräte-Code",
    hostname: "Hostname",
    status: "Status",
    manufacturer: "Hersteller",
    model: "Modell",
    tablet_serial: "Seriennummer",
    teamviewer_id: "TeamViewer-ID",
    device_uid: "Geräte-UID (SMBIOS)",
    location_id: "Standort-ID",
    location_name: "Standort-Name",
    export: "Exportieren",
    connect: "Verbinden",
    download_ps1: "Skript (.ps1) laden",
    download_installer: "Installer (.cmd) laden",
    download_exe_note: "Doppelklick-Installer – verhält sich wie eine .exe und installiert direkt.",
    custom_fields: "Zusätzliche Felder",
    columns: "Spalten",
    fields_hint: "Ziehen zum Sortieren · Anzeigeort wählen",
    place_table: "Tabelle",
    place_detail: "Detail",
    place_both: "Beide",
    place_off: "Aus",
    tv_changed: "TV-ID geändert",
    tv_prev: "vorher",
    no_agent: "Kein Agent",
    tv_reachable: "Erreichbar (TV)",
    agent_col: "Agent",
    installed: "installiert",
    not_installed: "kein Agent",
    unclear_code: "Unklarer Gerätecode – bitte korrigieren",
    import_data: "Import",
    import_running: "Importiere…",
    import_done: "Datensätze importiert",
    import_url_prompt: "Google-Sheet-Link (öffentlich, Betrachter):",
    rollout_title: "Rollout-Fortschritt",
    rollout_of: "von",
    rollout_installed: "Geräten mit Agent",
    agent_filter: "Agent",
    agent_installed_f: "Agent installiert",
    agent_missing_f: "Agent fehlt",
    bundesland: "Bundesland",
    ort: "Ort",
    auto_sync_on: "Auto-Sync aktiv",
    last_seen: "Zuletzt gesehen",
    os_version: "Betriebssystem",
    agent_version: "Agent-Version",
    first_seen: "Erstmals gesehen",
    actions: "Aktionen",
    no_devices: "Noch keine Geräte. Installiere den Agent auf einem Windows-Gerät.",
    activity: "Live-Aktivität",
    no_activity: "Noch keine Aktivität.",
    details: "Details",
    change_history: "Änderungsverlauf",
    no_history: "Keine Änderungen aufgezeichnet.",
    copy: "Kopieren",
    copied: "Kopiert!",
    save: "Speichern",
    cancel: "Abbrechen",
    edit: "Bearbeiten",
    delete: "Löschen",
    delete_confirm: "Dieses Gerät wirklich löschen?",
    connect_tv: "TeamViewer verbinden",
    note: "Notiz",
    filter_status: "Status",
    filter_manufacturer: "Hersteller",
    registered: "registriert",
    changed: "geändert",
    admin_edit: "Admin-Änderung",
    installer_title: "Windows-Agent installieren",
    installer_desc: "Ein Skript, ein Klick. Der Agent startet automatisch nach jedem Neustart und meldet sich alle 60 Sekunden.",
  },
  en: {
    brand: "Fleet Area",
    subtitle: "Device Fleet Monitoring",
    login_title: "Sign in",
    login_desc: "Sign in to manage your device fleet.",
    email: "Email",
    password: "Password",
    sign_in: "Sign in",
    signing_in: "Signing in…",
    logout: "Sign out",
    dashboard: "Overview",
    installer: "Install agent",
    search_placeholder: "Search: hostname, code, serial, UUID, TeamViewer…",
    total: "Total devices",
    online: "Online",
    offline: "Offline",
    unassigned: "Code pending",
    all: "All",
    device_code: "Device code",
    hostname: "Hostname",
    status: "Status",
    manufacturer: "Manufacturer",
    model: "Model",
    tablet_serial: "Serial number",
    teamviewer_id: "TeamViewer ID",
    device_uid: "Device UID (SMBIOS)",
    location_id: "Location ID",
    location_name: "Location name",
    export: "Export",
    connect: "Connect",
    download_ps1: "Download script (.ps1)",
    download_installer: "Download installer (.cmd)",
    download_exe_note: "Double-click installer – behaves like an .exe and installs directly.",
    custom_fields: "Custom fields",
    columns: "Columns",
    fields_hint: "Drag to reorder · choose location",
    place_table: "Table",
    place_detail: "Detail",
    place_both: "Both",
    place_off: "Off",
    tv_changed: "TV-ID changed",
    tv_prev: "was",
    no_agent: "No agent",
    tv_reachable: "Reachable (TV)",
    agent_col: "Agent",
    installed: "installed",
    not_installed: "no agent",
    unclear_code: "Unclear device code – please correct",
    import_data: "Import",
    import_running: "Importing…",
    import_done: "records imported",
    import_url_prompt: "Google Sheet link (public, viewer):",
    rollout_title: "Rollout progress",
    rollout_of: "of",
    rollout_installed: "devices with agent",
    agent_filter: "Agent",
    agent_installed_f: "Agent installed",
    agent_missing_f: "Agent missing",
    bundesland: "State",
    ort: "City",
    auto_sync_on: "Auto-sync on",
    last_seen: "Last seen",
    os_version: "Operating system",
    agent_version: "Agent version",
    first_seen: "First seen",
    actions: "Actions",
    no_devices: "No devices yet. Install the agent on a Windows device.",
    activity: "Live activity",
    no_activity: "No activity yet.",
    details: "Details",
    change_history: "Change history",
    no_history: "No changes recorded.",
    copy: "Copy",
    copied: "Copied!",
    save: "Save",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    delete_confirm: "Really delete this device?",
    connect_tv: "Connect via TeamViewer",
    note: "Note",
    filter_status: "Status",
    filter_manufacturer: "Manufacturer",
    registered: "registered",
    changed: "changed",
    admin_edit: "admin edit",
    installer_title: "Install Windows agent",
    installer_desc: "One script, one click. The agent auto-starts after every reboot and reports every 60 seconds.",
  },
};

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("fleet_lang") || "de");
  const change = (l) => {
    localStorage.setItem("fleet_lang", l);
    setLang(l);
  };
  const t = (key) => translations[lang][key] || key;
  return <LangContext.Provider value={{ lang, setLang: change, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
